<button type="button" class="btn btn-default btn-sm btn-dropdown" data-toggle="dropdown">
	<span>{{displayText}}</span><span class="caret"></span>
</button>
<ul class="dropdown-menu dropdown-scrollbar">
{{#each items}}
	<li>
		<a href="#" class="small" data-value="{{value}}" tabIndex="-1">
			<input type="checkbox" ></input>&nbsp;
			{{#if icon}}
				<i class="{{icon}}"></i>
			{{/if}}
			{{{text}}}
		</a>
	</li>
{{/each}}
{{#unless items}}
	<li>
		&nbsp;<small>{{noOptions}}</small>
	</li>
{{/unless}}
</ul>
<div>
	<small data-checklist-hint>$</small>
</div>